import { ValidationMessages } from "@/types/functions";

const validationES: ValidationMessages = {
    'min_length': '{field} debe tener al menos 0:{min} elementos seleccionados',
    'max_length': 'El {field} debe tener un máximo de 0:{max} elementos seleccionados',
    'multiple': 'El {field} debe ser múltiplo de 0:{multiple}'
}

export default validationES
